<template>
  <div class="wrapper">
    <div class="titlebar">
      <div class="wrap">
        <ul>
          <li class="logo-container">
            <a href="/">
              <img src="/Datatex Logo.png" alt="Logo" loading="lazy" />
            </a>
          </li>
          <li
            class="hamburger"
            @click="toggleMenu"
            :class="{ open: isMenuOpen }"
            aria-label="Toggle menu"
            role="button"
            tabindex="0"
          >
            <span></span>
            <span></span>
            <span></span>
          </li>
          <li class="navbuttons-container" :class="{ open: isMenuOpen }">
            <router-link class="navbutton" to="/">HOME</router-link>
            <router-link class="navbutton" to="/about">ABOUT US</router-link>
            <router-link class="navbutton" to="/solutions"
              >SOLUTIONS</router-link
            >
            <router-link class="navbutton" to="/support">SUPPORT</router-link>
            <router-link class="navbutton" to="/contact"
              >CONTACT US</router-link
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      isMenuOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
}

ul {
  /* Removed margin for better alignment */
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  list-style: none;
}

.logo-container img {
  width: 350px;
  display: block;
}

.hamburger {
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 25px;
  cursor: pointer;
  z-index: 1100;
}

.hamburger span {
  width: 100%;
  height: 3px;
  background-color: #2c4a66;
  border-radius: 2px;
  transition: all 0.3s ease;
  display: block;
}

.hamburger.open span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger.open span:nth-child(2) {
  opacity: 0;
}

.hamburger.open span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

.navbuttons-container {
  display: flex;
  gap: 16px;
}

.wrapper {
  margin: 0 auto;
  height: 115px;
  display: flex; /* enables vertical centering */
  align-items: center;
  background-color: white;
  position: fixed;
  top: 0;
  z-index: 1100;
  width: 100%;
  box-shadow: 0 5px 20px #888;
  /* Removed transition on transform to avoid sticky issues */
}

.titlebar,
.wrap {
  width: 100%;
}

.wrap {
  display: flex;
  justify-content: center;
  align-items: center;
}

.navbar {
  height: 50px;
  padding-left: 16px;
  overflow: hidden;
}

.navbutton {
  position: relative;
  display: inline-block;
  width: auto;
  padding: 0 15px;
  height: 50px;
  font-weight: bold;
  text-align: center;
  line-height: 50px;
  font-size: 17px;
  background: transparent;
  color: #2c4a66;
  cursor: pointer;
  text-decoration: none;
  transition: 0.3s ease-in-out;
}

.navbutton::after {
  content: "";
  position: absolute;
  bottom: 10px;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #2c4a66;
  transform: translateX(-50%);
  transition: width 0.3s ease, left 0.3s ease;
}

.navbutton:hover {
  transition: 0.3s ease-in-out;
  transform: scale(1.3);
  color: #2c4a66;
}

.navbutton:hover::after {
  width: 60%; /* or 100% if you want it full */
}

/* Responsive styles */
@media (max-width: 768px) {
  .logo-container img {
    width: 200px;
    margin-left: 5px;
  }

  .hamburger {
    display: flex;
  }

  .navbuttons-container {
    position: fixed;
    top: 100px;
    right: 0;
    background-color: white;
    height: calc(100% - 100px);
    width: 200px;
    flex-direction: column;
    gap: 0;
    padding-top: 20px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    transform: translateX(100%);
    transition: transform 0.3s ease;
    z-index: 1050;
  }

  .navbuttons-container.open {
    transform: translateX(0);
  }

  .navbutton {
    height: 50px;
    line-height: 50px;
    padding: 0 20px;
    font-size: 18px;
  }
}
</style>
system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto
Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI
Emoji","Segoe UI Symbol","Noto Color Emoji"
